import React, { Component } from 'react'

import {scaleTime, scaleOrdinal, scalePoint} from 'd3-scale'
import {interpolateRgb, timeParse} from "d3"

import Axes, { Points } from './movement-timeline'
import ResponsiveWrapper from './responsive-wrapper'

class DailyMovementReport extends Component {
  constructor(props) {
    super(props);
    this.xScale = scaleTime();
    this.yScale = scalePoint();
    this.colorScale = scaleOrdinal();
  }

  render() {
    const { data, height, parentWidth } = this.props;
    const margins = {top: 50, right: 20, bottom: 50, left: 100};
    const svgDimensions = {
      width: Math.max(parentWidth, 300),
      height: height
    };
    const set = [];
    const colors = [];

    data.map(d => {
      if (set.indexOf(d.zoneId) === -1) {
        set.push(d.zoneId);
      }
    });
    set.sort();

    for (let i = 0; i < set.length; i++) {
      colors.push(interpolateRgb('#1DC992', '#C91D5C')(i / set.length));
    }

    const parseTime = timeParse("%Y-%m-%dT%H:%M:%SZ");
    const startTime = Math.min(...data.map(d => parseTime(d.timeSeen)));
    const endTime = Math.max(...data.map(d => parseTime(d.timeSeen)));

    const xScale = this.xScale
      .domain([startTime, endTime])
      .range([margins.left, svgDimensions.width - margins.right]);

    const yScale = this.yScale
      .domain(set)
      .range([svgDimensions.height - margins.bottom, margins.top]);

    const colorScale = this.colorScale
      .domain([0, set.length])
      .range(colors);

    return (
      <svg width={svgDimensions.width} height={svgDimensions.height}>
        <Axes
          scales={{xScale, yScale}}
          margins={margins}
          svgDimensions={svgDimensions}
        />
        <Points
          scales={{xScale, yScale, colorScale}}
          data={data}
        />
      </svg>
    )
  }
}

export default ResponsiveWrapper(DailyMovementReport)



// WEBPACK FOOTER //
// ./src/pages/directory/contact-details/components/holder-zone-report/index.js